import { render, staticRenderFns } from "./BowCardWide.vue?vue&type=template&id=eef0d7a2&"
import script from "./BowCardWide.vue?vue&type=script&lang=js&"
export * from "./BowCardWide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowMedia: require('/workspace/components/molecules/BowMedia/BowMedia.vue').default,BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowButtonCircle: require('/workspace/components/atoms/BowButtonCircle/BowButtonCircle.vue').default})
